import axios from '../utils/axios'
import Qs from 'qs'

// 查询
export function getList(query) {
  return axios({
    url: '/customerBind/findCustomerBindList',
    method: 'get',
    params: query
  })
}

// 查询用户
export function getUser(query) {
  return axios({
      url: "/customerBind/findCustomer",
      method: 'get',
      params: query
  })
}
export function findWechatBind(query) {
  return axios({
    url: "/customerBind/findWechatBind",
    method: 'get',
    params: query
  })
}
export function updateWechatBind(query) {
  return axios({
    url: "/customerBind/updateWechatBind",
    method: 'post',
    params: query
  })
}



//缴费详情
export function getBill(query) {
  return axios({
    url: '/pay/bill',
    method: 'get',
    params: query
  })
}

// 绑定用户
export function bindUser(query) {
  return axios({
    url: '/customerBind/bind',
    method: 'post',
    data: query
  })
}

// 支付
export function pay(query) {
  return axios({
    url: "/pay/payOrder",
    method: 'post',
    data: query
  })
}

// 获取openId
export function getOpenId(query) {
  return axios({
    url: '/wechat/auth/accessToken',
    method: 'get',
    params: query
  })
}

// 获取微信
export function getWeixin(query) {
  return axios({
    url: "/wechat/auth/initWechatJsApi",
    method: 'get',
    params: query,
  })
}

// 解绑用户
export function untie(query) {
  return axios({
    url: '/customerBind/deleteBind?id='+query,
    method: 'get'
  })
}
/**
 * 查询热力公司
 */
export function getReli() {
  return axios({
    url: '/wechat/company/find',
    method: 'get'
  })
}

/**
 * 保存热力公司
 */
export function saveReli(data) {
  return axios({
    url: '/wechat/company/middle/save',
    method: 'post',
    data
  })
}

/**
 * 根据第三方id查询已绑定公司
 * @param {*} data
 */
export function getBindReli(data) {
  return axios({
    url: '/wechat/company/findMiddleOne?thirdId='+data,
    method: 'get'
  })
}

/**
 * 查询报修类型
 */
export function getTaskType(companyCode) {
  return axios({
    url: '/wechatTask/wechatTaskType?companyCode='+companyCode,
    method: 'get'
  })
}

/**
 * 报修
 */
export function baoxiu(data) {
  return axios({
    url: '/wechatTask/saveWechatTask',
    method: 'post',
    data
  })
}

/**
 * 报修进度
 */
export function baoxiuList(params) {
  return axios({
    url: `/wechatTask/find`,
    method: 'get',
    params
  })
}

/**
 * 评价
 */
export function pj(data) {
  return axios({
    url: '/wechatTask/upWechatTask',
    method: 'post',
    data
  })
}

/**
 * 缴费记录
 */
export function payLog(params) {
  return axios({
    url: `/pay/payLog`,
    method: 'get',
    params
  })
}

/**
 * 根据姓名查
 */
export function getName(params) {
  return axios({
    url: `/customerBind/fuzzyName`,
    method: 'get',
    params
  })
}
/**
 * 是否可以姓名查
 */
export function getIfByName(params) {
  return axios({
    url: `/wechat/company/findDetail`,
    method: 'get',
    params
  })
}

/**
 * 查询服务器信息
 */
export function getServeMsg(params) {
  return axios({
    url: `/wechat/mach/find?id=`+params,
    method: 'get'
  })
}

/**
 * 保存服务器信息
 */
export function saveServeMsg(data) {
  return axios({
    url: '/wechat/mach/save',
    method: 'post',
    data
  })
}

/**
 * 更名过户
 */
export function changeInfoName(data) {
  return axios({
    url: '/business/changeOwner',
    method: 'post',
    data
  })
}

/**
 * 获取面积
 */
export function findArea(params) {
  return axios({
    url: '/customerBind/findArea',
    method: 'get',
    params
  })
}

/**
 * 停 供
 */
export function saveMjtg(data) {
  return axios({
    url: '/business/saveMjtg',
    method: 'post',
    data
  })
}

/**
 * 复 供
 * @param data
 * @returns {AxiosPromise}
 */
export function saveMjfg(data) {
  return axios({
    url: '/business/saveMjfg',
    method: 'post',
    data
  })
}
/**
 * 权限
 * @param params
 * @returns {AxiosPromise}
 */
export function findRoles(params) {
  return axios({
    url: '/wechat/company/modulesAuth',
    method: 'get',
    params
  })
}

/**
 * 政策法规
 * */
export function wechatZcfg(companyCode,type){
  return axios({
    url: `/wechatTask/wechatZcfg?companyCode=${companyCode}&type=${type}`,
    method: 'get',
  })
}

/**
 * 人脸识别获取百度Token
 * */
export function baidurljc(){
  return axios({
    url:'/baidu/baiduToken',
    method:'get',
  })
}
/**
 * 人脸识别H5页面Token
 * */
export function verifyToken(){
  return axios({
    url:'/baidu/verifyToken',
    method: 'get'
  })
}

/**
 * 人脸识别H5页面Token
 * */
export function getYwjl(params){
  return axios({
    url:'/business/getYwjl',
    method: 'get',
    params
  })
}

/**
 * 字典项
 * @param names
 * @returns {AxiosPromise}
 */
export function dict(names) {
  return axios({
    url: '/sfparam/dict',
    method: 'post',
    params: {
      names: names,
      companyCode: sessionStorage.getItem('companyCode')
    }
  })
}

/**
 * 拒绝原因
 */
export function getJjyy(params){
  return axios({
    url:'/business/getReason',
    method: 'get',
    params
  })
}

/**
 * 根据用户名地址搜索
 * @param params
 * @returns {AxiosPromise}
 */
export function getBindYh(params){
  return axios({
    url:'/customerBind/getBindYh',
    method: 'get',
    params
  })
}

/**
 * 设置密码
 * @param params
 * @returns {AxiosPromise}
 */
export function setPassWord(params){
  return axios({
    url:'/customerBind/setPassWord',
    method: 'post',
    params
  })
}

/**
 * 判断
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserYhkh(params){
  return axios({
    url:'/customerBind/userYhkh',
    method: 'get',
    params
  })
}

/**
 * 判断用户是否黑名单
 * @param params
 * @returns {AxiosPromise}
 */
export function isCustomer(params) {
  return axios({
    url: '/wechatTask/isCustomer',
    method: 'get',
    params
  })
}

/**
* 获取短信验证码
* @param params
* @returns {AxiosPromise}
*/
export function getCaptcha(params) {
  return axios({
    url: '/wxSend/sms',
    method: 'get',
    params
  })
}

/**
 * 电子发票列表
 */
export function findPayToKp(params) {
  return axios({
    url: '/business/findPayToKp',
    method: 'get',
    params
  })
}

/**
 * 可开票金额校验
 * @param params
 * @returns {AxiosPromise}
 */
export function checkKpje(params) {
  return axios({
    url: '/business/checkKpje',
    method: 'get',
    params
  })
}

/**
 * 开发票
 * @param data
 * @returns {AxiosPromise}
 */
export function saveInvoic(data) {
  return axios({
    url: '/business/saveInvoic',
    method: 'post',
    data
  })
}

/**
 * 面积变更
 * @param data
 * @returns {AxiosPromise}
 */
export function saveMjbg(data) {
  return axios({
    url: '/business/saveMjbg',
    method: 'post',
    data
  })
}

/**
 * 模糊搜索小区
 * @param params
 * @returns {AxiosPromise}
 */
export function findLikeThree(params) {
  return axios({
    url: '/customerBind/findLikeThree',
    method: 'get',
    params
  })
}

/**
 * 级联查询
 * @param params
 * @returns {AxiosPromise}
 */
export function findCascadeMp(params) {
  params.companyCode = sessionStorage.getItem('companyCode')
  return axios({
    url: '/customerBind/findCascadeMp',
    method: 'get',
    params
  })
}

/**
 * 根据门牌号查用户
 * @param params
 * @returns {AxiosPromise}
 */
export function findByMp(params) {
  params.companyCode = sessionStorage.getItem('companyCode')
  return axios({
    url: '/customerBind/findByMp',
    method: 'get',
    params
  })
}

/**
 * 校验处理时限
 * @param params
 * @returns {AxiosPromise}
 */
export function validPzSlsx(params) {
  params.companyCode = sessionStorage.getItem('companyCode')
  return axios({
    url: '/business/validPzSlsx',
    method: 'get',
    params
  })
}

// 保存测温
export function saveCw(data) {
  return axios({
    url: 'wechatCw/saveCw',
    method: 'post',
    data
  })
}

export function tbXx(params) {
  return axios({
    url: '/customerBind/copyBind',
    method: 'get',
    params
  })
}

export function rwshSave(data) {
  return axios({
    url: '/business/rwshSave',
    method: 'post',
    data
  })
}

export function findRwshXq(params) {
  return axios({
    url: '/business/findRwshXq',
    method: 'get',
    params
  })
}

export function findRwshLog(params) {
  return axios({
    url: '/business/findRwshLog',
    method: 'get',
    params
  })
}





// WEBPACK FOOTER //
// ./src/api/index.js